// types
import { i18nCalendar } from 'models/i18n';

// ==============================|| I18N EN DELIVERY POINTS ||============================== //

const skCalendar: i18nCalendar = {
  createEventTitle: 'Vytvoriť udalosť',
  title: 'Operačný kalendár',
  availablePowerForTitle: ' : Dostupný výkon ',
  titleForContract: ' : Plnenie kontraktu ',
  toolbar: {
    todayButton: 'Dnes',
    viewOptions: {
      month: 'Mesiac',
      week: 'Týždeň',
      day: 'Deň',
      agenda: 'Agenda'
    },
    deviceGroup: 'Zariadenia',
    deliveryPointGroup: 'OOM',
    balanceGroupsGroup: 'Bilančné skupiny',
    showAll: 'Zobraziť všetky udalosti'
  },
  eventDialog: {
    input: {
      name: 'Názov udalosti',
      type: 'Typ udalosti',
      deviceId: 'Názov zariadenia',
      DeviceOffline: 'Neodostupné zariadenie',
      availablePower: 'Dostupný výkon',
      description: 'Popis udalosti',
      deliveryContractId: 'Kontrakt',
      AddButton: 'Pridať udalosť',
      EditButton: 'Upraviť udalosť',
      ChooseTime: 'Vyberte dátum a čas',
      invalidateButton: 'Zneplatniť udalosť'
    },
    meta: {
      createdBy: 'Vytvoril:',
      updatedBy: 'Upravil:'
    },
    validation: {
      'name-required': 'Názov udalosti je povinný',
      'name-max': 'Prekročená maximálna dĺžka',
      'type-required': 'Typ udalosti je povinný',
      'deviceId-required': 'Názov zariadenia je povinný',
      'description-max': 'Prekročená maximálna dĺžka',
      'deliveryContractId-required': 'Kontrakt je povinný',
      'availablePower-required': 'Výkon je povinný',
      'availablePower-number': 'Výkon musi byť čislo'
    },
    AllDay: 'Celý deň',
    NoEvents: 'Žiadne udalosti',
    CreateEventTitle: 'Vytvoriť udalosť',
    UpdateEventTitle: 'Upraviť udalosť',
    DeviceOffline: 'Nedostupné zariadenie',
    AvailablePower: 'Dostupný výkon',
    StartDate: 'Začiatok',
    EndDate: 'Koniec',
    EventDescription: 'Popis udalosti',
    DeleteButton: 'Zmazať',
    InvalidateButton: 'Invalidovať',
    CreateEventButton: 'Vytvoriť udalosť',
    SHUTDOWN: 'Vypnutie',
    MAINTENANCE: 'Údržba',
    MALFUNCTION: 'Porucha',
    CONTRACT: 'Kontrakt',
    ErrorStartInPast: 'Čas začiatku musí byť v budúcnosti',
    ErrorEndInPast: 'Čas konca musí byť v budúcnosti',
    ErrorStartTimeMessage: 'Čas začiatku je po čase ukončenia',
    ErrorEndTimeMessage: 'Čas ukončenia je pred časom začiatku',
    ContractWithoutName: 'Bez názvu'
  },
  activityLog: {
    title: 'História aktivít'
  },
  input: {
    Filter: ''
  }
};

export default skCalendar;
